module.exports = __webpack_public_path__ + "static/media/flexed-biceps.630312c4.png";